import { Role } from '@/types';
import { Chip } from '@mui/material';

interface RoleBadgeProps {
  role: Role;
}

const RoleBadge = ({ role }: RoleBadgeProps) => {
  return (
    <Chip
      label={role}
      size="small"
      color="primary"
      variant={
        role === Role.ADMIN || role === Role.OWNER ? 'filled' : 'outlined'
      }
    />
  );
};

export default RoleBadge;
